import { useState } from 'react'
import { StyleSheet, TouchableOpacity } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'

import { Palette } from '@ppwr/poker'

import { DS } from '../../design-system'

interface ClassListSelectionProps {
  list: string[]
  onPress: (item: string) => void
}
export const ClassListSelection = ({ list, onPress }: ClassListSelectionProps) => {
  const [selected, setSelected] = useState<string | null>(null)

  const onSelect = (item: string) => {
    setSelected(item)
    onPress(item)
  }

  return (
    <DS.Frame>
      <ScrollView contentContainerStyle={styles.scrollable}>
        {list.map((item, index) => (
          <TouchableOpacity
            key={index}
            style={[styles.item, item && selected && selected === item ? styles.selected : styles.unselected]}
            onPress={() => onSelect(item)}
          >
            <DS.Text variant="Body Large/Regular">{item}</DS.Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
    </DS.Frame>
  )
}

export const styles = StyleSheet.create({
  item: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 4,
    gap: 8,
    flexDirection: 'row',
    alignItems: 'center'
  },
  unselected: {
    borderWidth: 1,
    borderColor: Palette['Brand/Light Grey']
  },
  selected: {
    borderWidth: 2,
    borderColor: Palette['Global/Black']
  },
  scrollable: {
    gap: 8
  }
})
